import { get } from '@rails/request.js';
import { Controller } from 'stimulus';

// Re-renders the approval chips from the server on each `boards:shoppables-changed` event.
export default class extends Controller {
  static values = { url: String };

  #abortController;

  async refresh() {
    // A newer change supersedes an in-flight refresh, so a slow stale response can't win.
    this.#abortController?.abort();
    const abortController = new AbortController();
    this.#abortController = abortController;

    try {
      const response = await get(this.urlValue, { signal: abortController.signal });
      // A redirect means the session ended: keep the chips, don't render the login page.
      if (response.ok && !response.redirected) {
        this.element.innerHTML = await response.html;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        throw error;
      }
    }
  }

  disconnect() {
    this.#abortController?.abort();
  }
}
